import { withStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import Typography from 'components/CncUI/Typography';

const styles = ({ breakpoints }) => ({
  header: {
    textAlign: 'center',
  },
  body: {
    maxWidth: '90%',
    margin: '0 auto',
    [breakpoints.down('sm')]: {
      maxWidth: '100%',
    },
  },
});

const CoronaVirus = ({ classes = {} }) => (
  <Grid container spacing={2} direction="column" alignItems="center">
    <Grid item>
      <Typography
        variant="h3"
        id="CoronaVirusHeader"
        className={classes.header}
      >
        Coronavirus Announcement
      </Typography>
    </Grid>
    <Grid item>
      <Typography
        variant="body1"
        size="long"
        id="CoronaVirusBody"
        className={classes.body}
      >
        During the current Coronavirus (COVID-19) situation, Cast & Crew
        continues to operate with employee safety and client service top of
        mind. Cast & Crew has taken measures to ensure we are able to continue
        processing your payroll.
      </Typography>
    </Grid>
  </Grid>
);

export default withStyles(styles)(CoronaVirus);
